import { InteractiveLoginRequiredAuthError } from '@ms/yammer-web-authenticators';

export const isInteractiveLoginRequiredAuthError = (error: Error): error is InteractiveLoginRequiredAuthError =>
  error instanceof InteractiveLoginRequiredAuthError;
